$('.js-accordionTitle').click(function(){
	if($(this).hasClass('is-open')){
		$(this).removeClass('is-open')
	}else{
		$(this).addClass('is-open')
	}
	$(this).next('.p-homeFloor__detailDescription').slideToggle();
})